import DateFnsAdapter from '@date-io/date-fns';
import { de as dateFnsDe } from 'date-fns/locale';
import type { VuetifyOptions } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import * as labsComponents from 'vuetify/labs/components';
import { de } from 'vuetify/locale';

export const baseVuetifyOptions = {
  locale: {
    locale: 'de',
    messages: { de },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  date: {
    adapter: DateFnsAdapter,
    locale: {
      de: dateFnsDe,
    },
  },
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
} satisfies VuetifyOptions;
